import React, { useEffect, useState } from "react";
import { getSaleDetails } from "../../../../apis/auth";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ViewSale = () => {
    const {t} = useTranslation();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [sale, setSale] = useState(null);
    useEffect(() => {
        handleGetSaleDetails();
    }, []);

    const handleGetSaleDetails = async () => {
        try {
            const res = await getSaleDetails({ id });
            setSale(res.data.sale);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="p-8 text-center">
                Loading...
            </div>
        );
    }

    if (!sale) {
        return (
            <div className="p-8 text-center">
                Order not found
            </div>
        );
    }

    return (
        <div className="bg-gray-100 p-6 rounded-md">

            <div className="max-w-7xl mx-auto">
                <div className="bg-white rounded-xl shadow p-6 mb-6 flex justify-between items-center">

                    <div>
                        <h1 className="text-3xl font-bold">
                            Order #{sale.id}
                        </h1>

                        <p className="text-gray-500 mt-1">
                            {new Date(sale.created_at).toLocaleString()}
                        </p>
                    </div>

                    <span className="px-4 py-2 rounded-full bg-blue-100 text-blue-700 font-semibold capitalize">
                        {sale.sale_status.replace("_", " ")}
                    </span>

                </div>
                <div className="grid lg:grid-cols-2 gap-6">
                    <div className="bg-white rounded-xl shadow p-6">
                        <h2 className="font-bold text-lg mb-6">
                            Delivery Address
                        </h2>

                        {sale.delivery_address ? (
                            <div className="space-y-5">
                                <div>

                                    <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-400 mb-3">
                                        Customer Details
                                    </h3>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                        <div>
                                            <p className="text-xs text-gray-500">Full Name</p>
                                            {/* <p>{JSON.stringify(sale.delivery_address)}</p> */}
                                            <p className="font-medium">
                                                {sale.delivery_address.first_name} {sale.delivery_address.last_name}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs text-gray-500">Phone</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.phone || "-"}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs text-gray-500">Email</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.email || "-"}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs text-gray-500">Country</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.country}
                                            </p>
                                        </div>

                                    </div>

                                </div>
                                <hr />
                                <div>

                                    <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-400 mb-3">
                                        Address
                                    </h3>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                        <div>
                                            <p className="text-xs text-gray-500">State</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.state}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs text-gray-500">City</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.city}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs text-gray-500">Area</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.area}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs text-gray-500">Street</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.street}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs text-gray-500">House</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.house}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs text-gray-500">Apartment</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.apartment || "-"}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs text-gray-500">Floor</p>
                                            <p className="font-medium">
                                                {sale.delivery_address.floor || "-"}
                                            </p>
                                        </div>

                                        <div className="md:col-span-2">
                                            <p className="text-xs text-gray-500">Additional Instructions</p>
                                            <p className="font-medium">
                                                {sale.customer_notes}
                                            </p>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        ) : (

                            <div className="text-gray-500">
                                No delivery address available.
                            </div>

                        )}

                    </div>

                    {/* Payment */}

                    <div className="bg-white rounded-xl shadow p-6">

                        <h2 className="font-bold text-lg mb-4">
                            Payment
                        </h2>

                        <div className="space-y-2">

                            <div className="flex justify-between">
                                <span>Mode</span>
                                <span className="capitalize">
                                    {sale.payment_mode}
                                </span>
                            </div>

                            <div className="flex justify-between">
                                <span>Status</span>
                                <span className={`font-semibold ${sale.payment_status === "paid"
                                    ? "text-green-600"
                                    : "text-red-600"
                                    }`}>
                                    {t(sale.payment_status)}
                                </span>
                            </div>

                        </div>
                        <div className="py-6">

                            <h2 className="font-bold text-lg mb-6">
                                Order Summary
                            </h2>

                            <div className="space-y-3">

                                <div className="flex justify-between">
                                    <span>Items</span>
                                    <span>{sale.total_items}</span>
                                </div>

                                <div className="flex justify-between">
                                    <span>Quantity</span>
                                    <span>{sale.total_quantity}</span>
                                </div>

                                <div className="flex justify-between">
                                    <span>Subtotal</span>
                                    <span>KD {sale.total_amount}</span>
                                </div>

                                <div className="flex justify-between">
                                    <span>Shipping</span>
                                    <span>KD {sale.shipping_charge}</span>
                                </div>

                                <div className="flex justify-between text-red-600">
                                    <span>Discount</span>
                                    <span>
                                        -KD {sale.discounted_amount}
                                    </span>
                                </div>

                                <hr />

                                <div className="flex justify-between text-xl font-bold">

                                    <span>Total</span>

                                    <span>
                                        KD {sale.grand_total}
                                    </span>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-xl shadow mt-6 overflow-hidden">
                    <div className="p-6 border-b">
                        <h2 className="font-bold text-xl">
                            Ordered Products
                        </h2>
                    </div>

                    <div className="overflow-auto">

                        <table className="w-full">

                            <thead className="bg-gray-50">

                                <tr>

                                    <th className="text-left p-4">Product</th>

                                    <th className="text-center p-4">Qty</th>

                                    <th className="text-right p-4">Price</th>

                                    <th className="text-right p-4">Discount</th>

                                    <th className="text-right p-4">Total</th>

                                </tr>

                            </thead>

                            <tbody>

                                {sale.cart?.items?.map((item) => {

                                    const product =
                                        item.product
                                            ? JSON.parse(item.product)
                                            : {};

                                    return (

                                        <tr
                                            key={item.id}
                                            className="border-t"
                                        >

                                            <td className="p-4">

                                                <div className="flex items-center gap-4">

                                                    <img
                                                        src={product.image}
                                                        alt=""
                                                        className="w-16 h-16 rounded object-cover"
                                                    />

                                                    <div>

                                                        <div className="font-semibold">
                                                            {product.name}
                                                        </div>

                                                        <div className="text-sm text-gray-500">
                                                            {item.type}
                                                        </div>

                                                    </div>

                                                </div>

                                            </td>

                                            <td className="text-center">
                                                {item.item_quantity}
                                            </td>

                                            <td className="text-right">
                                                KD {item.item_sale_price}
                                            </td>

                                            <td className="text-right">
                                                KD {item.item_discount}
                                            </td>

                                            <td className="text-right pr-4 font-semibold">
                                                KD{" "}
                                                {(
                                                    item.item_sale_price *
                                                    item.item_quantity
                                                ).toFixed(2)}
                                            </td>

                                        </tr>

                                    );

                                })}

                            </tbody>

                        </table>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default ViewSale;